module.exports = __webpack_public_path__ + "img/slide9.2eb82197.png";